/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CognitoDisputeReason {
	DuplicateCharge = 'DuplicateCharge',
	Unauthorized = 'Unauthorized',
	ProductNotReceived = 'ProductNotReceived',
	NotAsDescribed = 'NotAsDescribed',
	CreditNotProcessed = 'CreditNotProcessed',
	Canceled = 'Canceled',
	Other = 'Other',
}
